<template>
  <div class="one-timings mb-3">
    <div class="one-timings-info-block">
      <div class="one-timings-info-block-name">Создана</div>
      <div class="one-timings-info-block-icon">
        <i class="bi bi-check-circle-fill text-success"></i>
      </div>
      <div class="one-timings-info-block-value">
        <span>{{ formatDateTime(model.create_time) }}</span>
      </div>
    </div>
    <div class="one-timings-info-block-separator">
      <i v-if="!timeGap1" class="bi bi-arrow-right"></i>
      <span v-else class="one-timings-time-between">{{ timeGap1 }}</span>
    </div>
    <div class="one-timings-info-block">
      <span class="one-timings-info-block-name">Решена</span>
      <div class="one-timings-info-block-icon">
        <i v-if="model.is_done" class="bi bi-check-circle-fill text-success"></i>
        <i v-else class="bi bi-play-circle-fill"></i>
      </div>
      <div class="one-timings-info-block-value">
        <span v-if="model.is_done">{{ formatDateTime(model.done_time) }}</span>
        <span v-else>В работе...</span>
      </div>
    </div>
    <div class="one-timings-info-block-separator">
      <i v-if="!timeGap2" class="bi bi-arrow-right"></i>
      <span v-else class="one-timings-time-between">{{ timeGap2 }}</span>
    </div>
    <div class="one-timings-info-block">
      <span class="one-timings-info-block-name">Синхр.</span>
      <div class="one-timings-info-block-icon">
        <i v-if="model.synchronizating" class="spinner-border spinner-border-sm"><span class="visually-hidden">Синхронизация...</span></i>
        <i v-else class="bi bi-check-circle-fill text-success"></i>
      </div>
      <div class="one-timings-info-block-value">
        <span v-if="model.synchronizating">Синхронизация...</span>
        <span v-else>{{ formatDateTime(model.sync_time || model.create_time) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateTime, formatTimer } from "@/helpers/date_time";

export default {
  props: [
      'model'
  ],
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
  },
  computed: {
    timeGap1() {
      if (!this.model.is_done) {
        return 0;
      }
      const time = this.model.done_time - this.model.create_time;
      return formatTimer(time, false);
    },
    timeGap2() {
      if (!this.model.is_done) {
        return 0;
      }
      if (this.model.synchronizating) {
        return 0;
      }
      const time = this.model.sync_time - this.model.done_time;
      return formatTimer(time, false);
    }
  }
}
</script>